import React, { useRef, useState } from 'react';
import NoDataComponent from 'Common/components/NoDataComponent';
import { resetNoDeviceFound, searchDeviceAccessDeniedAction } from 'ECD/basic-device-search/BasicSearchAction';
import { getBasicDeviceSearchUrl } from 'ECD/NGIApiUrls';
import { PopoverTooltip } from 'Global/PopoverTooltip';
import searchImg from "Common/img/SVG/PhoenixSearchIcons.svg";
import { connect } from 'react-redux';
import { ROUTE_DASHBOARD } from 'Common/constants/commonConstants';
import ErrorComponent from 'Common/components/ErrorComponent';
import SpinnerComponent from 'Common/components/SpinnerComponent';

const NavSearch = ({ dispatch, searchData }) => {
    const [target, setTarget] = useState(null);
    const overLayRef = useRef(null);
    const navSearch = useRef(null);

    const searchKeyPress = (event) => {
        if (target == null) {
            setTarget(event.target);
        }
        if(searchData.noDeviceFound){
            dispatch(resetNoDeviceFound());
        }
        if (event.key === 'Enter') {
            //Check if istance  already searched if yes just switch tab
            let instanceId = event.target.value.trim();
            if (instanceId.length > 0) {
                const win = window.open(ROUTE_DASHBOARD + instanceId, "_blank");
                win.focus();
            }
        }
    }
    const callsubmit = (event) => {
        event.preventDefault();
        setTarget(event.target);
        console.log("submit called");
    }
    const resetInputData =() =>{
        if(navSearch && navSearch.current){
        navSearch.current.value = "";
        }
    }
    const handleErrorComponentClose = () =>{
        dispatch(searchDeviceAccessDeniedAction(false));
        window.close();
    }

    const searchInputLostFocus = () => {
        if (searchData.isFetched && searchData.noDeviceFound) {
            dispatch(resetNoDeviceFound());
        }
    }

    return (
        <>
        <form ref={overLayRef} className="form-inline" onSubmit={callsubmit} autoComplete="off">
            <div className="nav-search-padding" >
                 <span id="nav_search_span">
                    <img src={searchImg} className="nav-search-icon"></img>
                </span>
                <input ref={navSearch} type="text" className="form-control" id="nav_search" placeholder="INSTANCE" onKeyDown={searchKeyPress} onBlur={searchInputLostFocus} />
                <PopoverTooltip message={<SpinnerComponent />} target={navSearch} show={!!navSearch?.current?.value && searchData.isFetching} reference={overLayRef} />
                {searchData.isFetched && searchData.deviceFound && navSearch.current.value && resetInputData()}
                <PopoverTooltip message={<NoDataComponent />} target={navSearch} show={!!navSearch?.current?.value && searchData.isFetched && searchData.noDeviceFound} reference={overLayRef} />
            </div>
        </form>
        <ErrorComponent heading='REQUEST ACCESS'
                message='You do not have access to the Instance Dashboard. Please contact DxS IntelliServe support team to request access'
                handleClose={() => handleErrorComponentClose()} 
                show={searchData.accessDenied}/>
        </>
    );
}

function select(state) {
    return {
        searchData: state.BasicSearchReducer
    };
}
export default connect(select)(NavSearch)